import { render } from "./OrderPoolFile.vue?vue&type=template&id=712201a1&ts=true"
import script from "./OrderPoolFile.vue?vue&type=script&lang=ts"
export * from "./OrderPoolFile.vue?vue&type=script&lang=ts"

import "./OrderPoolFile.vue?vue&type=style&index=0&id=712201a1&lang=css"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__